import React from 'react'
import { observer } from 'mobx-react-lite'
import { Breadcrumb } from 'antd'
import { contexts } from '@/domains'
import { useLocalStorage } from '@/utils/useSparrowLocalStorage'

const { GlobalContext } = contexts

export type Props = {
  name: string
  tips?: string
}

const SiteBreadcrumb = (props: Props): JSX.Element => {
  
  const { name, tips } = props

  const { currentTeam } = GlobalContext.useContainer()
  return (
    <div style={{ padding: '20px 0', display: 'flex', alignItems: 'center' }}>
      <Breadcrumb
        items={[
          { title: currentTeam?.teamName },
          { title: name },
        ]}
      />
      {
        tips && <div style={{ flex: 1, textAlign:'right' }}>{tips}</div>
      }
    </div>
  )
}

export default observer(SiteBreadcrumb)
